import gsap from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

(function initVideoParallaxPin() {
    const section = document.querySelector('.section-video-parallax-blocks');
    if (!section) return;

    const videoBox = section.querySelector('.main-video-box');
    if (!videoBox) return;

    // Pin the video box while scrolling inside the section
    ScrollTrigger.create({
        trigger: section,
        start: 'top top',
        end: 'bottom bottom',
        pin: videoBox,
        pinSpacing: false,       // keeps next sections from getting pushed down; good for "video behind content" effect
        anticipatePin: 1,
        invalidateOnRefresh: true,
    });

    // If images/fonts/videos change layout after load, refresh triggers
    window.addEventListener('load', () => ScrollTrigger.refresh());
})();
